import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components/Text/Text';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Note = styled(Text)`
  display: block;
  font-size: 12px;
  line-height: 1.5;
  color: ${COLORS.textFaint};
`;
